export const initialState = {
    filter: {
        nameKeyword: null,
        idKeyword: null,
        positionName: null,
        regionalName: null,
        page: null,
        size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const leaderSearchReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_LEADER":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
        };
      default:
        return state;
    }
  };
  
  export default leaderSearchReducer;
  